import {
    FETCH_ATHLETE_SUCCEEDED,
    FETCH_ATHLETES_SUCCEEDED,
    FETCH_TEAMS_SUCCEEDED,
    FETCH_PROGRAM_SCHEDULES_SUCCEEDED,
    CREATE_PROGRAM_SCHEDULE_SUCCEEDED,
    CREATE_TEAM_SUCCEEDED,
    PATCH_TEAM_SUCCEEDED,
    REMOVE_TEAM_SUCCEEDED,
    SIGN_OUT_SUCCEEDED,
    SWITCH_ORGANIZATION,
} from 'shared_redux/actions';

import { Model, fk, many, attr } from 'redux-orm';

const updateIfChanged = (Model, json) => {
    const existing = Model.withId(json.id);
    if (existing
        && existing.last_modified === json.last_modified && existing.created_on === json.created_on
        && !(!existing.default_group_id && json.default_group_id)) { // HACK: older team models that lack default_group_id should be overridable if default_group_id shows up in a later one
        return;
    }
    Model.upsert(json);
};

class Teams extends Model {

    static reducer(action, Teams, session) {
        switch (action.type) {
            case FETCH_ATHLETE_SUCCEEDED:
                if (action.payload.team) {
                    updateIfChanged(Teams, action.payload.team);
                }
                // Handle nested team from group.team
                if (action.payload.group && action.payload.group.team) {
                    updateIfChanged(Teams, action.payload.group.team);
                }
                break;
            case FETCH_ATHLETES_SUCCEEDED:
                action.payload.forEach(athlete => {
                    if (athlete.team) {
                        updateIfChanged(Teams, athlete.team);
                    }
                    // Also extract teams from nested group.team
                    if (athlete.group && athlete.group.team) {
                        updateIfChanged(Teams, athlete.group.team);
                    }
                });
                break;
            case FETCH_TEAMS_SUCCEEDED:
                // Upsert teams without clearing existing ones
                // This preserves teams referenced by program schedules that may have been
                // stored via CREATE_PROGRAM_SCHEDULE_SUCCEEDED before this fetch completed
                // Stale data is cleared on SIGN_OUT_SUCCEEDED
                action.payload.forEach(team => {
                    // Remove 'groups' property (it's handled by the Groups reducer)
                    // Keep default_group_id which is provided by the server
                    const {groups, ...rawTeam} = team;
                    updateIfChanged(Teams, rawTeam);
                });
                break;
            case FETCH_PROGRAM_SCHEDULES_SUCCEEDED: {
                for (var schedule of action.payload) {
                    if (schedule.team) {
                        updateIfChanged(Teams, schedule.team);
                    }
                }
                break;
            }
            case CREATE_PROGRAM_SCHEDULE_SUCCEEDED: {
                if (action.payload.team) {
                    updateIfChanged(Teams, action.payload.team);
                }
                break;
            }
            case CREATE_TEAM_SUCCEEDED:
                Teams.upsert(action.payload);
                break;
            case PATCH_TEAM_SUCCEEDED:
                Teams.withId(action.payload.id).update(action.payload);
                break;
            case REMOVE_TEAM_SUCCEEDED:
                Teams.withId(action.id).delete();
                break;
            case SIGN_OUT_SUCCEEDED:
            case SWITCH_ORGANIZATION:
                Teams.all().delete();
                break;
        }
    }

}
Teams.modelName = 'Teams';

Teams.fields = {
    id: attr(),
    name: attr(),
    is_default: attr(),
    organization_id: attr(),
    default_group_id: attr(),
};

export default Teams;
